<div class="modal__container">
    <ng-container>
        <h3>{{ 'opType_DYNSIG' | translate }}</h3>
        <mat-selection-list [multiple]="false">
            <mat-list-option *ngFor="let operation of operations"
                (click)="selectOperationType(operation.operationType)">
                {{ ('opType_' + operation.operationType) | translate }}
            </mat-list-option>
        </mat-selection-list>
    </ng-container>
</div>